function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useState } from "react";
import classNames from "classnames";
import Icon from "../Icon";
var UICollapse = function(param) {
    var children = param.children, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, id = param.id, primaryText = param.primaryText, secondaryText = param.secondaryText;
    var _useState = _slicedToArray(useState(false), 2), open = _useState[0], setOpen = _useState[1];
    var btnClasses = classNames("title", {
        open: open,
        disabled: disabled
    });
    return /*#__PURE__*/ React.createElement("li", {
        className: "app-menu__chapter"
    }, /*#__PURE__*/ React.createElement("button", {
        className: btnClasses,
        "aria-expanded": open,
        "aria-controls": id,
        disabled: disabled,
        onClick: function() {
            return setOpen(!open);
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "title-wrapper"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "title-super"
    }, "".concat(primaryText, " ")), /*#__PURE__*/ React.createElement("span", null, secondaryText)), !disabled ? /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right",
        size: "m"
    }) : null), /*#__PURE__*/ React.createElement("ul", {
        className: "chart-menu".concat(open ? " open" : ""),
        id: id,
        hidden: !open || disabled
    }, children));
};
export default UICollapse;
